import { render, staticRenderFns } from "./TradeNews.vue?vue&type=template&id=03d65174&scoped=true"
import script from "./TradeNews.vue?vue&type=script&lang=js"
export * from "./TradeNews.vue?vue&type=script&lang=js"
import style0 from "./TradeNews.vue?vue&type=style&index=0&id=03d65174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d65174",
  null
  
)

export default component.exports